import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "../../../Layout/AuthLayout";
import OtpModal from "./OTPModal";
import { forgetPassword } from "../../../services/User/Authentication";
import toast from "react-hot-toast";

const ForgetPass = () => {
  const [email, setEmail] = useState("");
  const [openOtp, setOpenOtp] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setLoading(true);
    try {
      const res = await forgetPassword({ email });
      toast.success(res.message || "OTP sent to your email");
      setOpenOtp(true);
    } catch (err) {
      toast.error(err.error || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthLayout>
        <h2 className="xl:text-[28px] md:text-2xl text-xl text-[var(--color-text)] mb-2">
          Forgot Password
        </h2>
        <p className="xl:text-base md:text-sm text-xs text-[var(--color-text-muted)] mb-8">
          Enter your email to receive a reset OTP
        </p>

        <form
          onSubmit={handleSubmit}
          className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 text-left"
        >
          <div className="mb-6">
            <label className="md:text-sm text-xs label-caps block mb-2" htmlFor="email">
              EMAIL
            </label>
            <input
              id="email"
              autoComplete="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-[var(--color-bg)] border border-[var(--color-border)] rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full xl:text-base md:text-sm text-xs bg-[var(--color-primary)] text-black border-none p-3 rounded-[var(--radius-md)] font-extrabold uppercase tracking-[0.06em] ${loading ? "cursor-not-allowed" : "cursor-pointer"}`}
          >
            {loading ? "SENDING..." : "SEND RESET CODE"}
          </button>
        </form>

        <p className="flex justify-center items-center gap-1 mt-6 xl:text-base md:text-sm text-xs text-[var(--color-text-muted)]">
          Back to{" "}
          <Link to="/login" className="text-[var(--color-primary)] font-extrabold">
            Login
          </Link>
        </p>
      </AuthLayout>

      {/* OTP Modal */}
      <OtpModal
        open={openOtp}
        handleClose={() => setOpenOtp(false)}
        email={email}
        type="forgot"
      />
    </>
  );
};

export default ForgetPass;
